module.exports = "/_next/static/images/btn-ok-6a27d224.png";